/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Marcus Biesel <m.biesel@techdivision.com>
 */

import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { errorSignal } from '../Signals/errorSignal';

/**
 * ErrorMessage Component
 * @returns {React.JSX.Element|null}
 * @constructor
 */
export function ErrorMessage() {
  const error = errorSignal.signal;

  const handleCloseAlert = () => {
    error.value = null;
  };

  if (error.value) {
    return (
      <Snackbar
        open={Boolean(error)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000001 }}
      >
        <Alert sx={{ alignItems: 'center' }} variant="filled" severity="error" onClose={handleCloseAlert}>
          <div>{error.value}</div>
        </Alert>
      </Snackbar>
    );
  }

  return null;
}
